module.exports = __webpack_public_path__ + "img/1_9_1.bd64f071.jpg";